import { createSelector } from 'reselect';
import { isNaN, toNumber } from 'lodash/fp';

import { getAgrBracketFromAges } from '../select-age-bracket';
import AgrService from '../../models/agr';
import getIncomeTierOptions from '../../utils/get-income-tier-options';
import selectRawPrice from '../select-raw-price';

// @ts-expect-error - Automatic, Please fix when editing this file
const selectCustomerFormValues = (state, values) => values;

export default createSelector([selectCustomerFormValues, selectRawPrice], (customerFormValues, rawPrice) => {
  const { age, incomeTier, incomeType, partnerAge } = customerFormValues;
  const ageBracket = getAgrBracketFromAges([age, partnerAge]);

  const incomeTierAsNumber = toNumber(incomeTier);
  if (isNaN(incomeTierAsNumber)) {
    return 0;
  }
  // @ts-expect-error - Automatic, Please fix when editing this file
  const { value } = getIncomeTierOptions({ incomeType })[incomeTierAsNumber];

  return AgrService.getPercentage(
    {
      ageBracket,
      incomeTier: value,
      rebate: true,
    },
    {
      useFutureEffectiveDate: rawPrice?.useFutureEffectiveDate,
    },
  );
});
